module.exports = __webpack_public_path__ + "static/media/zettel.97345b4c.jpg";